export default __webpack_public_path__ + "static/media/loader_Gym.da1940bb.gif";